// extracted by mini-css-extract-plugin
export default {"inlineSvg":"GFyra"};